module.exports = __webpack_public_path__ + "static/media/expat-logo.18824d50.svg";